import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["align", "alignSm", "alignMd", "alignLg", "alignXl", "alignXxl", "as", "className", "color", "children", "italic", "opacity", "renderChildrenAsHTML", "transform", "truncate", "type", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classnames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var typeElementMap = {
  'heading-1': 'h1',
  'heading-2': 'h2',
  'heading-3': 'h3',
  'heading-4': 'h4',
  'sub-heading-1': 'h5',
  'sub-heading-2': 'h6',
  'body-text-1': 'p',
  'body-text-2': 'p'
};
var Typography = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classnames;

  var align = _ref.align,
      alignSm = _ref.alignSm,
      alignMd = _ref.alignMd,
      alignLg = _ref.alignLg,
      alignXl = _ref.alignXl,
      alignXxl = _ref.alignXxl,
      as = _ref.as,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'body' : _ref$color,
      children = _ref.children,
      italic = _ref.italic,
      opacity = _ref.opacity,
      renderChildrenAsHTML = _ref.renderChildrenAsHTML,
      transform = _ref.transform,
      truncate = _ref.truncate,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'body-text-1' : _ref$type,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      props = _objectWithoutProperties(_ref, _excluded);

  var Element = as || typeElementMap[type];

  var getContent = function getContent() {
    if (!renderChildrenAsHTML) {
      return children;
    }

    if (typeof children !== 'string') {
      throw Error('You can only use `renderChildrenAsHTML` if the children is a `string`.');
    }

    return /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: {
        __html: children
      }
    });
  };

  return /*#__PURE__*/_jsx(Element, _objectSpread(_objectSpread({
    className: classnames(className, type, 'typography', (_classnames = {}, _defineProperty(_classnames, "text-".concat(color), color), _defineProperty(_classnames, "text-".concat(align), align), _defineProperty(_classnames, "text-sm-".concat(alignSm), alignSm), _defineProperty(_classnames, "text-md-".concat(alignMd), alignMd), _defineProperty(_classnames, "text-xl-".concat(alignXl), alignXl), _defineProperty(_classnames, "text-xxl-".concat(alignXxl), alignXxl), _defineProperty(_classnames, "text-".concat(opacity), opacity), _defineProperty(_classnames, "text-".concat(transform), transform), _defineProperty(_classnames, 'text-truncate', truncate), _defineProperty(_classnames, 'fst-italic', italic), _classnames)),
    ref: ref,
    id: id
  }, props), {}, {
    children: getContent()
  }));
});
export default Typography;